import { render, staticRenderFns } from "./AgoraNotif.vue?vue&type=template&id=97e7e3de&"
import script from "./AgoraNotif.vue?vue&type=script&lang=js&"
export * from "./AgoraNotif.vue?vue&type=script&lang=js&"
import style0 from "./AgoraNotif.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports